<template>
  <div class="m-1 p-3 order-card border">
    <div class="order-card-details">
      <p class="p-0 m-0 font-weight-light font-italic">{{date}}</p>
      <p class="p-0 m-0 font-weight-bold">{{`ORDER NO: ${orderno}`}}</p>
      <p class="p-0 m-0 mb-3">{{name}}</p>
    </div>
    <div class="order-card-parts">
      <b-collapse v-model="showParts" :id="`parts-collapse-${orderno}`" class="order-card-parts">
        <span class="px-2 font-weight-bold">NOTE:</span>
        <span class="font-weight-light">{{!note ? "N/A" : note }}</span>
        <b-table class="my-4" :items="partsForTable"></b-table>
      </b-collapse>
    </div>
    <div
      class="order-card-details-summary d-flex flex-row align-items-center justify-content-start text-success"
    >
      <p>{{`${parts.length} parts ordered`}}</p>
    </div>
    <div class="order-card-show-parts">
      <b-button @click="showParts = !showParts">Show Details</b-button>
    </div>
    <div class="order-card-more">
      <b-dropdown size="sm" variant="outline" no-caret>
        <template slot="button-content">
          <span>
            <i class="material-icons">more_horiz</i>
          </span>
        </template>
        <b-dropdown-item @click="print">Print order</b-dropdown-item>
        <b-dropdown-item @click="download">download .ord file</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderno: Number
  },
  data() {
    return {
      showParts: false
    };
  },
  methods: {
    print() {
      let printBody = `JEPARTS ORDER
      -----------------------
      Order Number: ${this.orderno}
      Date: ${this.date}
      Customer Name: ${this.name}
      Dealer Number: ${this.customerID}
      Customer Email: ${this.email}
      Note: ${this.note}

      Parts:
      `;

      this.parts.forEach(p => {
        printBody += `${p.part_number} x ${p.orderQuantity}\n`;
      });
      printBody += "-----------------------\n";
      let temporaryWindow = window.open();
      temporaryWindow.document.write(
        `<span style="white-space:pre-line">${printBody}</span>`
      );
      temporaryWindow.print();
      temporaryWindow.close();
    },
    download() {
      // TODO:  refactor
      let orderFile = `Y
      
${this.customerID}
\n\n\n\n\n\n\n\n
${this.customerID}
CTA
`;
      this.parts.forEach(p => {
        orderFile += `${p.part_number}
${p.orderQuantity}
${p.dealer_price}
${p.vendor}
${p.class}
N
`;
      });

      let hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(orderFile);
      hiddenElement.target = "_blank";
      hiddenElement.download = `${this.orderno}.ord`;
      hiddenElement.click();
    }
  },
  computed: {
    name() {
      return this.$store.getters["orderInState"](this.orderno).customer_name;
    },
    email() {
      return this.$store.getters["orderInState"](this.orderno).customer_email;
    },
    partsForTable() {
      return this.$store.getters["orderInState"](this.orderno).parts.map(p => ({
        partNumber: p.part_number,
        orderQuantity: p.orderQuantity
      }));
    },
    parts() {
      return this.$store.getters["orderInState"](this.orderno).parts;
    },
    note() {
      return this.$store.getters["orderInState"](this.orderno).note;
    },
    customerID() {
      return this.$store.getters["orderInState"](this.orderno).customer_id;
    },
    date() {
      return new Date(
        this.$store.getters["orderInState"](this.orderno).date
      ).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/mixins";
@import "../styles/variables";

.order-card {
  width: 100%;
  max-width: 45em;

  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas:
    "details  more"
    "details  ."
    "summary  show"
    " . . "
    "parts parts";

  &-details {
    grid-area: details;

    &-summary {
      grid-area: summary;
    }
  }
  &-show-parts {
    grid-area: show;
    button {
      float: right;
    }
  }
  &-parts {
    grid-area: parts;
  }
  &-more {
    grid-area: more;
    .b-dropdown {
      float: right;
    }
  }
  @include desktop {
    grid-template-columns: auto auto auto auto;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      "details details more     more"
      "details details summary  show"
      "parts   parts   parts    parts";
  }

  @include tablet {
    grid-template-columns: auto auto auto auto;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      "details details more     more"
      "details details summary  show"
      "parts   parts   parts    parts";
  }
}
</style>
